import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { Box, Button } from "@mui/material";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { LEAVE_GRANT_TABLE_HEAD } from "../../../../components/datagrid/leave/LeaveGrantTableHead";
import { getLeaveGrantRequests } from "../../../../redux/features/leaveSlice";
import ApproveLeaveGrant from "./ApproveLeaveGrant";

const LeaveGrantRequest = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, requests } = useSelector((state) => state.leave);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [action, setActionOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();

  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  const columns = useMemo(
    () => [
      ...LEAVE_GRANT_TABLE_HEAD,
      {
        field: "Action",
        minWidth: 200,
        headerName: "Actions",
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="contained"
              color="primary"
              disabled={params.row.created_user === profile?.userId}
              startIcon={<Icon icon={"picon:plus"} width={18} height={18} />}
              onClick={() => {
                setSelectedRow(params.row);
                setActionOpen(true);
              }}
            >
              Action
            </Button>
          );
        },
      },
    ],
    [LEAVE_GRANT_TABLE_HEAD]
  );

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search || "",
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getLeaveGrantRequests(data));
    }
  }, [pageNum, gridSize, search]);

  return (
    <GlobalWrapper title={"Department WFH Grant Requests"}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={requests?.data}
          meta={requests?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="leave_id"
          rowClick={false}
        />
        {action && selectedRow && (
          <ApproveLeaveGrant
            open={action}
            setOpen={setActionOpen}
            row={selectedRow}
            dispatchData={data}
          />
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default LeaveGrantRequest;
